import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GeneralHealthData } from '@models/medical-history.model';
import { AlertService } from '@services/alert.service';
import { MedicalHistoryService } from '@services/medical-history.service';
import { take } from 'rxjs';

@Component({
  selector: 'gc-general-health',
  templateUrl: './general-health.component.html',
  styleUrls: ['./general-health.component.scss'],
  standalone: false,
})
export class GeneralHealthComponent implements OnInit, OnChanges {
  @Input() userId: number;
  @Input() generalHistory: GeneralHealthData;
  @Input() requestUuid: string | null = null;
  @Output() submittedStep = new EventEmitter<{ step: string; values: any }>();

  generalHistoryForm: FormGroup;

  readonly options = {
    smoking: ['Ex-Smoker', '0', '1-5', '5-10', '10-15', '15-20', '20+'],
    alcohol: ['0', '1-5', '5-10', '10-15', '15-20', '20+'],
    exercise: [...Array(6).keys()].map(String),
    recreationalDrugs: ['Never', 'Previously', 'Regularly', 'Occasional', 'Rarely'],
  };

  constructor(
    private readonly fb: FormBuilder,
    private readonly medicalHistoryService: MedicalHistoryService,
    private readonly alertService: AlertService,
  ) {}

  ngOnInit() {
    this.generalHistoryForm = this.fb.group({
      smoking: this.fb.group({
        value: [''],
        note: [''],
      }),
      alcohol: this.fb.group({
        value: [''],
        note: [''],
      }),
      exercise: this.fb.group({
        value: [''],
        note: [''],
      }),
      recreational_drugs: this.fb.group({
        value: [''],
        note: [''],
      }),
    });
    this.generalHistoryForm.patchValue({
      ...(this.generalHistory ?? {}),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['generalHistory'] && !changes['generalHistory'].firstChange) {
      this.generalHistoryForm.patchValue({
        ...(this.generalHistory ?? {}),
      });
    }
  }

  saveToRequest() {
    this.medicalHistoryService
      .saveRequestMedicalHistory$(this.requestUuid, 'general_health', this.generalHistoryForm.value)
      .pipe(take(1))
      .subscribe((request) => {
        if (request) {
          this.submittedStep.emit({
            step: 'generalHealth',
            values: this.generalHistoryForm.value,
          });
          this.alertService.snackbar('general_history_saved');
        }
      });
  }

  saveToProfile() {
    this.medicalHistoryService
      .saveMedicalHistory$(this.userId, 'general_health', { user_id: this.userId, general_health: this.generalHistoryForm.value })
      .subscribe(() => this.alertService.snackbar('general_history_saved'));
  }

  submit() {
    if (this.requestUuid) {
      this.saveToRequest();
    } else {
      this.saveToProfile();
    }
  }
}
